import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { BuyCreditsComponent } from './buy-credits.component';
import { AuthenticationService } from '../core/authentication/authentication.service';
import { MessageBoxService } from '../shared/dialog/messagebox.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class BuyCreditsService {

  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService,
    private messageBoxService: MessageBoxService,
    private authenticationService: AuthenticationService
  ) {
    this.dialog = dialog;
  }

  showBuyCreditsDialog(credits: number): Observable<boolean> {
    const dialogRef: MatDialogRef<BuyCreditsComponent> = this.dialog.open(BuyCreditsComponent, {
      width: '600px',
      maxWidth: 'none',
      disableClose: false
    });
    dialogRef.componentInstance.credits = credits;
    //
    return dialogRef.afterClosed();
  }

  buyCredits(credits: number, subscriptionId: string = '') {
    let expireDate = '';
    if (credits !== -1) {
      const credentials = this.authenticationService.credentials;
      if (credentials && credentials.admin) {
        for (let i = 0; i < credentials.admin.length; i++) {
          const admin = credentials.admin[i];
          if (admin.type === 's') {
            if (admin.expireDate >= expireDate) {
              subscriptionId = admin.subscriptionId;
              expireDate = admin.expireDate;
            }
          }
        }
      }
      if (subscriptionId) {
        this.showBuyCreditsDialog(credits).subscribe({
          next: (result: any) => {
            if (result) {
              const credentials = this.authenticationService.credentials;
              if (credentials) {
                let subscriptionId = '';
                let expireDate = '';
                for (let i = 0; i < credentials.admin.length; i++) {
                  const admin = credentials.admin[i];
                  if (admin.type === 's') {
                    if (admin.expireDate >= expireDate) {
                      subscriptionId = admin.subscriptionId;
                      expireDate = admin.expireDate;
                    }
                  }
                }
                if (subscriptionId) {
                  const prefix = (window as any).origin.startsWith('https://web.smxstudio.it') ? 'www' : 'test';
                  const url = `https://${prefix}.anastasis.it/acquisto/smxstudio/${result.id}?ana-smx-subscription-id=${subscriptionId}`;
                  window.open(url, '_blank');
                }
              }
            }
          },
          error: (err) => {
            console.error(err);
          }
        });
      } else {
        this.messageBoxService.showTextMessage(
          this.messageBoxService.MODE_TYPE.OK,
          this.translateService.instant('MSG_ERROR'),
          this.translateService.instant('ERROR_SUBSCRIPTION_ID')
        ).subscribe();
      }
    }
  }


}
